import { render, staticRenderFns } from "./ConfirmationPrompt.vue?vue&type=template&id=6d63448c"
import script from "./ConfirmationPrompt.vue?vue&type=script&lang=ts"
export * from "./ConfirmationPrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports